module.exports = "/_next/static/images/trezor_logo_horizontal-d7485d76f800049299e57de1ca4da54a.svg";